module.exports = __webpack_public_path__ + "static/media/calendar.d620422e.gif";